import { render, staticRenderFns } from "./ReturnOrderDetails.vue?vue&type=template&id=3615ab8e&"
import script from "./ReturnOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports